export default {
  date: 'date',
  datetime: 'datetime',
  currency: 'currency',
  card: 'card',
  image: 'image',
  status: 'status',
  link: 'link',
} as const;
